import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(
    private router: Router,
    private toastr: ToastrService
  ) { }

  /* =========================================
     SAVE SESSION
  ========================================= */

  setSession(res: any): void {

    localStorage.setItem('authToken', res.authHeader);

    localStorage.setItem(
      'userType',
      res.login.userType
    );

    localStorage.setItem(
      'userData',
      JSON.stringify(res.login)
    );

    /*
      ONLY USER SESSION EXPIRY
    */

    if (res.login.userType === 'USER') {

      // 24 HOURS
      const expiryTime =
        new Date().getTime() +
        (2 * 60 * 1000);

      localStorage.setItem(
        'sessionExpiry',
        expiryTime.toString()
      );
    }
  }

  /* =========================================
     CHECK SESSION
  ========================================= */

  checkSessionExpiry(): void {

    const userType =
      localStorage.getItem('userType');

    /*
      ADMIN NO EXPIRY
    */

    if (
      userType === 'ADMIN' ||
      userType === 'SUPER_ADMIN'
    ) {
      return;
    }

    const expiry =
      localStorage.getItem('sessionExpiry');

    if (!expiry) {
      return;
    }

    const currentTime =
      new Date().getTime();

    /*
      SESSION EXPIRED
    */

    if (currentTime > Number(expiry)) {

      /*
        CLEAR STORAGE
      */

      localStorage.clear();

      /*
        SHOW ERROR
      */

      this.toastr.error(
        'Session expired. Please login again.'
      );

      /*
        REDIRECT LOGIN
      */

      this.router.navigate(['/customer-login']);
    }
  }

  /* =========================================
     LOGOUT
  ========================================= */

  logout(): void {

    localStorage.clear();

    this.router.navigate(['/login']);
  }
}